export default __webpack_public_path__ + "static/media/offer-banner.62d16245.png";